import AsyncStorage from '@react-native-community/async-storage'
import { flow } from 'mobx'
import api from '../api'

class AuthStore {
    login = flow(function* (email, password) {
        try {
            const response = yield api.login(email, password)
            if (response.status == 200) {
                const { token, tokenExpAt } = response.data
                yield AsyncStorage.setItem('@token', token)
                yield AsyncStorage.setItem('@tokenExpAt', tokenExpAt)
                return Promise.resolve()
            }
            throw (null)
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateInstallation = flow(function* (fcmToken, scheme, token) {
        try {
            const response = yield api.updateInstallation(fcmToken, scheme, token)
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })
}

export default new AuthStore()